import React from 'react';
import './styles.css';

const InboxTab = props => {
  const { actions } = props;
  const { caption, icon, handler, selected } = actions;

  let iconClass;

  switch (icon) {
    case 'inbox':
      iconClass = 'inbox-tab__icon--inbox';
      break;
    case 'sent':
      iconClass = 'inbox-tab__icon--sent';
      break;
    case 'invitations':
      iconClass = 'inbox-tab__icon--invitations';
      break;
    case 'delete':
      iconClass = 'inbox-tab__icon--delete';
      break;
    default:
      iconClass = null;
  }

  const selectedClass = selected
    ? ' inbox-tab inbox-tab--selected'
    : 'inbox-tab';

  const onClick = () => {
    handler();
  };

  return (
    <div className={selectedClass}>
      <div className="inbox-tab__content">
        <button className="inbox-tab__action" onClick={onClick}>
          <span
            className={`inbox-tab__icon ${iconClass}`}
            aria-label={caption}
            role="img"
          />
          <span className="inbox-tab__caption">{caption}</span>
        </button>
      </div>
    </div>
  );
};

export default InboxTab;
